import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=87977042&scoped=true"
import script from "./relation.vue?vue&type=script&lang=js"
export * from "./relation.vue?vue&type=script&lang=js"
import style0 from "./relation.vue?vue&type=style&index=0&id=87977042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87977042",
  null
  
)

export default component.exports